import { put, takeLatest, call } from "redux-saga/effects";
import {
    GET_ALL_REPORT_LISTS_REQUESTED,
    GET_ALL_REPORT_LISTS_SUCCESS,
    GET_ALL_REPORT_LISTS_FAILED,
} from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import {
  makeSecuredPostRequest,
} from "../../../appApi/AppApi";
import { createActionOf } from "../../actions/ActionCreator";

const TAG = "getReportsFilterDataSaga.js";

function* workerGetReportsFilterData({data={}}) {
  try {
    const response = yield call(
      makeSecuredPostRequest,
      API_ENDPOINT.GET_ALL_FILTER_DATA_FOR_DETAILED_REPORTS,
      data.payload
    );
    
    yield put(createActionOf(GET_ALL_REPORT_LISTS_SUCCESS, 1, response));
  } catch (error) {
    console.error(TAG, "Worker get all lists for failed: " + error.message);
    yield put(createActionOf(GET_ALL_REPORT_LISTS_FAILED, 2, error));
  }
}


export const watchGetReportsFilterData = takeLatest(
    GET_ALL_REPORT_LISTS_REQUESTED,
    workerGetReportsFilterData
)